import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { DateToLocal } from "components/dates";
import { Tooltip } from "components/tooltip";
import { Icon } from "@blueprintjs/core";
import { ListingTable } from "components/listing";
import moment from "moment";
import { HelperFunctions } from "helpers";
import { Modal, ModalSize } from "components/notifications";
import { ShowHide } from "components/layout";

const defaultArray = [];

export function EmployeeLicenceCheckEntitlements({
    entitlements = defaultArray,
    checkDate,
    options
}) {

    const tableHeaders = ["Status", "Category", "Type", "Description", "Valid From", "Valid To", "Number of Restrictions"];
    const restrictionHeaders = ["Code", "Restriction"];
    const [tableRows, setTableRows] = useState([]);
    const [restrictionRows, setRestrictionRows] = useState([]);
    const [selectedRestriction, setSelectedRestriction] = useState(null);

    useEffect(() => {

        const isEntitlementValid = (entitlement) => {
            const today = moment();
            const validFrom = moment(entitlement.validFrom);
            const validTo = moment(entitlement.validTo);

            //if either of the valid dates are set and the current date is outside of the range, return false
            return !((validFrom.isValid() && today.isBefore(validFrom)) || (validTo.isValid() && today.isAfter(validTo)));
        }

        const sortedEntitlements = HelperFunctions.sortAlphabetically(entitlements, "category");

        setTableRows(sortedEntitlements.map((entitlement) => {

            const matchedOption = options.find((option) => option.code === entitlement.category);

            return [
                isEntitlementValid(entitlement) ? <span className="text-intent-success">Active</span> : <span className="text-intent-danger">Inactive</span>,
                entitlement.category,
                entitlement.categoryType,
                <div key={`${entitlement.category}-${entitlement.validFrom}-${entitlement.validTo}`} className="inline-items">
                    <div className="inline-items">
                        {matchedOption?.name}
                    </div>
                    <div className="inline-items">
                        <Tooltip content={entitlement.description}>
                            <Icon icon="info-sign" size={12} />
                        </Tooltip>
                    </div>
                </div>,
                <DateToLocal key={`${entitlement.category}-${entitlement.validFrom}-${entitlement.validTo}`} format="DD/MM/YYYY">{entitlement.validFrom ?? '-'}</DateToLocal>,
                <DateToLocal key={`${entitlement.category}-${entitlement.validFrom}-${entitlement.validTo}`} format="DD/MM/YYYY">{entitlement.validTo ?? '-'}</DateToLocal>,
                entitlement.restrictions.length === 0 ? "0" : <button className="button-link text-intent-danger" onClick={() => { mapRestrictions(entitlement.restrictions, entitlement.category) }} >{entitlement.restrictions.length}</button>,
            ];
        }));
    }, [entitlements, options]);

    function mapRestrictions(restrictions, category) {
        setSelectedRestriction(category);
        setRestrictionRows(restrictions.map((restriction) => {
            return [
                restriction.code,
                restriction.description
            ]
        }));
    }

    return (
        <div>

            <ShowHide
                evaluator={checkDate != null}
                show={(
                    <div className="spacer-bottom">
                        <p>The information below was captured and was accurate as of the <DateToLocal format="DD/MM/YYYY">{checkDate ?? '-'}</DateToLocal></p>
                    </div>
                )}
            />

            <ListingTable
                id="listing-table-licence-entitlements"
                noDataMessage={"No entitlements on the employee's record"}
                sortable={false}
                headers={tableHeaders}
                data={tableRows}
                totalRecordCount={tableRows.length}
                loadingData={false}
                pageable={false}
                showPerPage={false}
                shrinkLastColumn

            />

            <Modal isOpen={selectedRestriction != null} title={`Restrictions for Category ${selectedRestriction}`} size={ModalSize.SMALL} onClose={() => { setSelectedRestriction(null) }}>
                <ListingTable
                    id="listing-table-licence-entitlement-restrictions"
                    sortable={false}
                    headers={restrictionHeaders}
                    data={restrictionRows}
                    totalRecordCount={restrictionRows.length}
                    loadingData={false}
                    pageable={false}
                    showPerPage={false}
                />
            </Modal>

        </div>
    );
}

EmployeeLicenceCheckEntitlements.propTypes = {
    entitlements: PropTypes.array.isRequired,
    checkDate: PropTypes.string,
    options: PropTypes.array.isRequired
};